function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function randomizeGrid(grid) {
  const limit = parseInt(grid.dataset.randomizeLimit || '0', 10);
  if (!limit) return;
  const cards = Array.from(grid.querySelectorAll(':scope > .review-cards__card'));
  if (cards.length <= limit) {
    cards.forEach(c => c.removeAttribute('hidden'));
    return;
  }
  const shuffled = shuffle(cards.slice());
  const keep = new Set(shuffled.slice(0, limit));
  // Re-append in random order so DOM reflects the new sequence
  shuffled.forEach(card => {
    if (keep.has(card)) {
      card.removeAttribute('hidden');
      grid.appendChild(card);
    } else {
      card.setAttribute('hidden', '');
    }
  });
}

function init() {
  document.querySelectorAll('.review-cards__grid[data-randomize-limit]').forEach(randomizeGrid);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
